export default __webpack_public_path__ + "static/media/instagram.54fd554f.svg";